import axios from 'axios';
import AuthService from 'services/Auth';

class TranslateApi {
  translate(text, targetLocales) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/translate`,
      method: 'post',
      data: {
        text,
        target_locales: targetLocales,
      },
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default new TranslateApi();
